import { motion } from "framer-motion";
import { MapPin, Phone, Clock, Navigation } from "lucide-react";
import { shop } from "../../data";

export default function Contact() {
  const today = new Date().getDay(); // 0 = domenica
  const orderMap = [6, 0, 1, 2, 3, 4, 5]; // hours array index for JS day
  const todayIdx = orderMap[today];

  const mapEmbed = `https://www.google.com/maps?q=${encodeURIComponent(
    shop.mapsQuery
  )}&output=embed`;

  return (
    <section
      id="contatti"
      data-testid="contact-section"
      className="py-24 md:py-32 scroll-mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="text-xs tracking-[0.2em] uppercase text-[#C24E77] mb-6">
            Vieni a trovarci
          </div>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-[#123D5B] leading-tight">
            Ti aspettiamo in
            <span className="italic text-[#C24E77]"> negozio.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
          <motion.div
            initial={{ opacity: 0, x: -24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7 }}
            className="rounded-2xl overflow-hidden border border-black/5 shadow-[0_16px_48px_rgba(45,40,37,0.1)] min-h-[380px]"
          >
            <iframe
              title="Mappa La casa del pigiama"
              src={mapEmbed}
              className="w-full h-full min-h-[380px]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7 }}
            className="bg-[#FBEFF3] rounded-2xl border border-[#123D5B]/8 p-8 md:p-10 flex flex-col"
          >
            <div className="space-y-6">
              <div className="flex gap-4">
                <MapPin className="text-[#C24E77] shrink-0 mt-1" size={20} aria-hidden="true" />
                <div>
                  <p className="text-xs tracking-[0.15em] uppercase text-[#C24E77] mb-1">Indirizzo</p>
                  <p className="text-[#123D5B]">{shop.address}</p>
                </div>
              </div>
              <div className="flex gap-4">
                <Phone className="text-[#C24E77] shrink-0 mt-1" size={20} aria-hidden="true" />
                <div>
                  <p className="text-xs tracking-[0.15em] uppercase text-[#C24E77] mb-1">Telefono</p>
                  <a href={shop.phoneHref} className="text-[#123D5B] hover:text-[#C24E77] transition-colors">
                    {shop.phone}
                  </a>
                </div>
              </div>
              <div className="flex gap-4">
                <Clock className="text-[#C24E77] shrink-0 mt-1" size={20} aria-hidden="true" />
                <div className="w-full">
                  <p className="text-xs tracking-[0.15em] uppercase text-[#C24E77] mb-2">Orari</p>
                  <ul className="space-y-1.5">
                    {shop.hours.map((h, i) => (
                      <li
                        key={h.day}
                        className={`flex justify-between text-sm ${
                          i === todayIdx ? "text-[#C24E77] font-500" : "text-[#4A5863]"
                        }`}
                      >
                        <span>{h.day}{i === todayIdx ? " · oggi" : ""}</span>
                        <span>{h.time}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-[#123D5B]/8 flex flex-col sm:flex-row gap-3">
              <a
                href={shop.phoneHref}
                data-testid="contact-call-button"
                className="flex-1 inline-flex items-center justify-center gap-2 bg-[#123D5B] hover:bg-[#0C2A40] text-white rounded-sm px-6 py-3.5 transition-all duration-300 hover:-translate-y-0.5"
              >
                <Phone size={17} aria-hidden="true" /> Chiama
              </a>
              <a
                href={shop.mapsUrl}
                target="_blank"
                rel="noreferrer"
                data-testid="contact-directions-button"
                className="flex-1 inline-flex items-center justify-center gap-2 border border-[#C24E77]/40 text-[#C24E77] hover:bg-[#123D5B] hover:text-white rounded-sm px-6 py-3.5 transition-all duration-300"
              >
                <Navigation size={17} aria-hidden="true" /> Indicazioni
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
